import { AlertService } from './../services/alert.service';
import { FormGroup, FormControl } from '@angular/forms';
import { FormType } from '../enums';
import { IDataGridSource, IDataGridPageRequest } from '../interfaces';
import * as moment from 'moment';

export namespace FUNCTIONS {

    export const IsConstructor = f => {
        try {
            Reflect.construct(String, [], f);
        } catch (e) {
            return false;
        }
        return true;
    };

    export const IsValidObject = obj => {
        return (
            typeof obj === 'object' &&
            obj &&
            !Array.isArray(obj) &&
            !moment.isMoment(obj) &&
            IsConstructor(obj.constructor)
        );
    };

    export const ArrayToString = (arr): string => {
        let str = '';
        if (arr != null) {
            arr.forEach((i, index) => {
                str += i;
                if (index != arr.length - 1) {
                    str += ',';
                }
            });
        }
        return str;
    };

    export function ValidateFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched();
            } else if (control instanceof FormGroup) {
                ValidateFormFields(control);
            }
        });
    }

    export function ClearFormErrors(formGroup: FormGroup) {
        formGroup.markAsPristine();
        formGroup.markAsUntouched();
        formGroup.updateValueAndValidity();
    }

    export function getFormValue(formGroup: FormGroup, prop: string) {
        if (!prop) {
            return formGroup.value;
        }
        return formGroup.get(prop).value;
    }

    export function CheckBeforeClose(
        alertSvc: AlertService,
        formType: FormType,
        confirmMsg = 'Se va a cerrar el formulario ¿Continuar?'
    ) {
        return new Promise<void>(resolve => {
            if (formType !== FormType.CONSULTAR) {
                alertSvc.open(confirmMsg, null, { confirm: true }).then(confirm => {
                    if (confirm) {
                        resolve();
                    }
                });
            } else {
                resolve();
            }
        });
    }

    export function ArrayAny<T>(arr: T[], predicated: (value: T) => boolean = null) {

        if (predicated) {
            return arr.filter(predicated).length > 0;
        }

        return arr.length > 0;
    }

    export function GridRequestFromSource(source: IDataGridSource<any>, newPage: number = null, newPageSize: number = null): IDataGridPageRequest {
        return {
            page: newPage ? newPage : source.page,
            pageSize: newPageSize ? newPageSize : source.pageSize,
            orderBy: source.orderBy,
            orderDir: source.orderDir
        };
    }

    export function ConvertObjectToGetParams(obj, keyParent = null) {
        let resp = {};
        Object.keys(obj).forEach(k => {
            const value = obj[k];
            const key = keyParent ? `${keyParent}.${k}` : k;

            if (value !== undefined && value !== null) {
                if (Array.isArray(value)) {
                    resp[key] = ArrayToString(value);
                } else if (IsValidObject(value)) {
                    const children = ConvertObjectToGetParams(value, key);
                    resp = { ...resp, ...children };
                } else if (moment.isMoment(value)) {
                    resp[key] = value.format('YYYY-MM-DD');
                } else {
                    resp[key] = String(obj[k]);
                }
            }
        });
        return resp;
    };

    export const formatNumber = (value: number) => {
        return new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 2
        }).format(value);
    }
}